import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './i18n'
import { routes } from './routes'
import { PageLoading } from './components/PageLoading'
import { SiteMeasurement } from './components/SiteMeasurement'
import { initializeAppearance } from './lib/theme'
import type { BuildData } from './lib/buildData'

initializeAppearance()
const router = createBrowserRouter([{ element: <SiteMeasurement />, children: routes }], { future: { v7_relativeSplatPath: true } })
const queryClient = new QueryClient()
const publicBuildData = document.getElementById('public-build-data')?.textContent

if (publicBuildData) {
  try {
    const { catalog, plans, supportContact } = JSON.parse(publicBuildData) as Pick<BuildData, 'catalog' | 'plans' | 'supportContact'>
    queryClient.setQueryData(['public-catalog'], catalog)
    queryClient.setQueryData(['public-plans'], plans)
    queryClient.setQueryData(['public-support-contact'], supportContact, { updatedAt: 0 })
  } catch {
    // Keep the regular API requests as a fallback if the build data is invalid.
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} fallbackElement={<PageLoading fullScreen delay={0} />} />
    </QueryClientProvider>
  </React.StrictMode>,
)
